export default {
    inb: {
        loading: {
            upload: "Die Datei wird verarbeitet ...",
            create: "Das Ereignis wird angelegt ...",
        },
        button: {
            messages: "Inbox Meldungen "
        },

        drop: {
            customer: "Kunde der Meldung entspricht nicht dem Kunden im Ereignis",
            unit    : "Die Anlage aus der Meldung entspricht nicht den Anlagen aus dem Ereignis",
            type    : "Der Meldungstyp ist für das Ereignis nicht zugelassen."
        },

        adp: {
            success                : "Automatische Verarbeitung erfolgreich",
            error                  : "Fehler bei der automatischen Verarbeitung",
            in_progress            : "Automatische Verarbeitung läuft...",
            insufficient_confidence: "Konfidenz zu gering für automatische Zuordnung",
            confidence             : "Konfidenz",
        },

        upload: {
            label   : "Datei hier ablegen",
            hint    : "Dateien hier ablegen",
            subtitle: "oder per Drag & Drop hochladen",
            imported: "Die Meldung wurde bereits am {0} von {1} importiert.",
            invalid : "Es können nur Microsoft Outlook Mails mit der Endung .msg oder PDF Dateien mit der Endung pdf importiert werden.",
            errors: {
                exists: {
                    title  : "Die Meldung existiert bereits",
                    message: "Die Meldung wurde bereits am {0} von {1} importiert.",
                    action : "Trotzdem verarbeiten"
                }
            },
            confirm: {
                title  : "Duplikate erkannt",
                store  : "Duplikate verarbeiten",
                message: "Die nachfolgenden Meldungen wurden zu einen frühreren Zeitpunkt bereits im Liftmanager verarbeitet. Bitte die Dateien, die erneut verarbeitet werden sollen anhaken und bestätigen.",
                exists: {
                    query: "Die Meldung existiert bereits",
                    text : "Die Meldung wurde bereits am {0} von {1} importiert. Soll die Meldung erneut importiert werden?"
                }
            },
            typeSelect: {
                title   : "Meldungsart wählen",
                hint    : "Für die hochzuladende(n) Datei(en) ({0}) bitte die Meldungsart auswählen:",
                label   : "Meldungsart",
                confirm : "Hochladen",
                showMore: "+{0} weitere Dateien anzeigen",
                showLess: "weniger anzeigen"
            }
        },

        //
        // Inbox overview table
        //
        overview: {
            customer: {
                all    : "Alle Meldungen",
                without: "Meldungen ohne Kunde",
                edit   : "Inbox Parameter für Kunden bearbeiten",

                dialog: {
                    mailbox: "Mailbox",
                    sender : "Email Adressen"
                }
            },
            menu: {
                export : "Daten exportieren",
                refresh: "Anzeige aktualisieren",
                filter : {
                    off: "Meldungen werden gefiltert",
                    on : "Meldungen werden nicht gefiltert"
                },
                deletefilter: {
                    off: "Gelöschte Meldungen werden nicht anzeigt",
                    on : "Gelöschte Meldungen werden anzeigt"
                }
            },
            header: {
                state   : "S",
                type    : "T",
                received: "Eingang",
                message : "Meldung",
                status  : "Status",
                filename: "Datei",
                customer: "Kunde",
                sender  : "Sender",
                sites   : "Anlagen",
                subject : "Betreff"
            },
            title       : "Meldungen",
            hints: {
                customer: "Kunde konnte nicht ermittelt werden",
                sites   : "Anlagen konnten nicht ermmittelt werden",
                subject : "Betreff konnte nicht ermittelt werden"
            },

            imports: {
                upload: "Datei Upload",
            },

            attachments: {
                expand: {
                    on : "weitere {0} Dokumente",
                    off: "weniger Dokumente anzeigen"
                }
            }
        },

        morph: {
            query: "<span style='color:red'>Meldungsart ändern?</span>",
            text : "Mit <b>JA</b> wird die Meldungsart nach <b>{0}</b> geändert. Mit der Änderung der Meldungsart <b>gehen i.d.R. Daten verloren</b> und müssen erbeut erfasst werden. Soll die Änderung der Meldungsart nun durchgeführt werden?",
        },

        //
        // Inbox message dialog
        //
        edit: {
            menu: {
                zoomon       : "Anzeige Vergößern",
                zoomoff      : "Anzeige verkleinern",
                save         : "Änderungen speichern",
                create       : "Ereignis zur Meldung anlegen",
                creategoto   : "Ereignis zur Meldung anlegen und zur Bearbeitung wechseln",
                goto         : "Ereignis zur Meldung bearbeiten",
                confirm      : "Meldung quittieren",
                edit         : "Meldung bearbeiten",
                confirmReset : "Quittierung zurücksetzen",
                ignore       : "Meldung löschen",
                ignoreReset  : "Gelöschte Meldung wieder herstellen",
                reload       : "Meldung neu laden",
                delete       : "Meldung löschen",
                deleteReset  : "Meldung wieder herstellen",
                detach       : "Meldung vom Ereignis lösen",
                query: {
                    detach   : "Soll die Meldung vom Ereignis gelöst werden?",
                    delete   : "Soll die Meldung gelöscht werden?",
                    undelete : "Soll die Löschung rückgängig gemacht werden?",
                    confirm  : "Soll die Meldung quittiert werden?",
                    unconfirm: "Soll die Quitiierung rückgängig gemacht werden?"
                }
            }
        },


        menu: {
            site: {
                notfound: "Anlage konnte nicht ermittelt werden"
            },
            assessment: {
                type: "{0} vom {1}"
            }
        },
        detail: {
            side           : "Meldungen",
            head: {
                title          : "Meldung",
            },
            assessment: {
                title: {
                    main   : "Prüfung",
                    contact: "Kontakt",
                    comment: "Bemerkung",
                    defects: "Mängelliste"
                },
                typetext   : "Art der Prüfung aus Prüfbericht",
                type       : "Art der Prüfung",
                resulttext : "Ergebnis aus Prüfbericht",
                result     : "Ergebnis",
                fabricNo   : "Fabriknummer",
                customer   : "Kunde",
                date       : "Datum der Prüfung",
                dateNext   : "Nächste Prüfung",
                dateRemedy : "Nachprüfung bis",
                contact: {
                    name   : "Name",
                    phone  : "Telefon",
                    mail   : "Email",
                    mobile : "Mobile"
                },
            },
            issue: {
                incidentTime: "Wann wurde gemeldet?",
                transferTime: "Wann weitergegeben?"
            }
        },

        maintenance: {
            exedate: "Leistungsdatum",
        }
    },
}